import { useEffect, useState } from "react";
import api from "../../../utils/axiosInstance";
import VendorJobsTable, { VENDOR_JOBS_EXPORT_COLUMNS } from "./VendorJobsTable";
import { exportTable } from "../../../utils/exportTable";
import { btn } from "../../../components/Button/buttonStyles";

const VendorJobsPage = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchJobs = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await api.get("/vendor-jobs", { withCredentials: true });
      setJobs(response.data.data || []);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const handleExportToExcel = () => {
    exportTable("my-jobs", VENDOR_JOBS_EXPORT_COLUMNS, jobs);
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">Jobs</h1>
        <div className="flex items-center gap-2 text-sm">
          <button
            onClick={handleExportToExcel}
            className={btn("secondary", "sm")}
          >
            Export to Excel
          </button>
        </div>
      </div>

      {loading && (
        <div className="flex justify-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border border-gray-300 border-t-brand-600" />
        </div>
      )}
      {error && <p className="text-danger-600 text-sm">{error}</p>}

      {!loading && !error && (
        <>
          <p className="text-sm text-gray-600">
            Showing <span className="font-semibold">{jobs.length}</span> items.
          </p>

          <VendorJobsTable data={jobs} onRefresh={fetchJobs} />
        </>
      )}
    </div>
  );
};

export default VendorJobsPage;
